import { MobileCard } from '@/Components/shared/List/MobileCard';
import { DeliveryProofState } from '../types/delivery-proof.types';
import type { DeliveryProofResponseDto } from '../types/delivery-proof.types';

function getStateBadgeClass(state: DeliveryProofState) {
  switch (state) {
    case DeliveryProofState.PENDING_SIGNATURE: return 'tw-bg-yellow-100 tw-text-yellow-800';
    case DeliveryProofState.SENT: return 'tw-bg-blue-100 tw-text-blue-800';
    case DeliveryProofState.SIGNED: return 'tw-bg-green-100 tw-text-green-800';
    case DeliveryProofState.CANCELED: return 'tw-bg-red-100 tw-text-red-800';
    default: return 'tw-bg-gray-100 tw-text-gray-800';
  }
}

function getStateLabel(state: DeliveryProofState) {
  switch (state) {
    case DeliveryProofState.PENDING_SIGNATURE: return 'En attente signature';
    case DeliveryProofState.SENT: return 'Envoyée';
    case DeliveryProofState.SIGNED: return 'Signée';
    case DeliveryProofState.CANCELED: return 'Annulée';
    default: return state;
  }
}

interface DeliveryProofMobileCardsProps {
  data: DeliveryProofResponseDto[];
  onRowClick?: (dp: DeliveryProofResponseDto) => void;
}

export function DeliveryProofMobileCards({ data, onRowClick }: DeliveryProofMobileCardsProps) {
  return (
    <div className="tw-space-y-3">
      {data.map((dp) => {
        const beneficiary = dp.beneficiary
          ? `${dp.beneficiary.firstname} ${dp.beneficiary.lastname}`
          : '-';
        const vehicle = dp.vehicle
          ? `${dp.vehicle.registration} - ${dp.vehicle.brand} ${dp.vehicle.model}`
          : '-';

        return (
          <MobileCard
            key={dp.id}
            title={dp.contractNum || dp.dpNumber || '-'}
            subtitle={dp.isLegacy ? 'Legacy' : undefined}
            status={
              <span className={`tw-px-2 tw-py-1 tw-text-xs tw-font-medium tw-rounded-full ${getStateBadgeClass(dp.state)}`}>
                {getStateLabel(dp.state)}
              </span>
            }
            fields={[
              { label: 'Bénéficiaire', value: beneficiary },
              { label: 'Véhicule', value: vehicle, fullWidth: true },
              { label: 'Date', value: new Date(dp.createdAt).toLocaleDateString('fr-FR') },
            ]}
            onClick={onRowClick ? () => onRowClick(dp) : undefined}
          />
        );
      })}
    </div>
  );
}
